// @flow

//
// Formatter
//
import {
    fmtQuantity,
} from '../../../../../lib/trix-web-data-commons';

const getConfiguration = (props: any) => {
    return {
        onGetOptionLabel: (option: any) => {
            let stockSkuName = '';
            if (option.stock) {
                stockSkuName = option.stock.sku;
                if (option.stock.name.bg) {
                    stockSkuName = stockSkuName + ' ' + option.stock.name.bg;
                }
                if (option.quantity) {
                    stockSkuName = stockSkuName + ' (' + fmtQuantity(option.quantity) + ')';
                }
            } else {
                stockSkuName = 'Unknown';
            }
            return stockSkuName;
        }
    }
}
export default getConfiguration;